import React, { useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { GlobalConstants } from "src/data/GlobalConstants";
import { modalCRUDService } from "src/services/modalCRUDService";
import ImagePickerCrop from "src/components/ImagePickerCrop";
import { marcasService } from "src/services/unoauno/apiMarcas";
import { getCurrentTime, toBlob } from "src/util/functions";
import { proveedoresService } from "src/services/unoauno/apiProveedores";

const FormImagenesProveedores = ({ properties }) => {
    const { idProveedor, urlImagen, reload } = properties;

    const dispatch = useDispatch();

    const [urlImagenProveedor, setUrlImagenProveedor] = useState( urlImagen ?? "" );
    const previewRef = useRef(null);

    const onClickGuardar = async () => {
        try {
            if(previewRef?.current) {
                const nombreImg = `pro_${idProveedor}_${getCurrentTime()}.png`

                const blobImg = await toBlob(previewRef.current);
                const file = new File([blobImg], nombreImg);

                await proveedoresService.saveImagen({file, idProveedor, nombreImg, extension: "/proveedores"})
            }
            
            reload(); 
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            console.log(error);
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Ha ocurrido un error, comunicate con soporte" } });
        }
    }

    return (
        <div className="px-2">
            <Tooltip className="m-0" title="Guardar" aria-label="Guardar" style={{position: "absolute", right: "3.5%"}}>
                <a onClick={onClickGuardar} className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                </a>
            </Tooltip>

            <div className="container w-100 mx-0 px-0 mt-1">
                <strong style={{fontSize: "13pt"}}>Imagen del proveedor:</strong>
                <div className="px-3 mt-4">
                    <ImagePickerCrop urlImagen={urlImagenProveedor} previewRef={previewRef}/>
                </div>
            </div>
        </div>
    )
}

export default FormImagenesProveedores;